var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSiteLoadDone && (_vm.isMobile || !_vm.site.isMenuHorizontalStyle)
    ? _c(
        "b-sidebar",
        {
          staticClass: "vertical-style",
          attrs: {
            backdrop: "",
            visible: _vm.isMegaMenuOpen,
            shadow: "",
            "no-header": ""
          },
          on: { change: _vm.megaMenuVisibilityChanged }
        },
        [
          _c(
            "div",
            {
              staticClass: "menu-content-container",
              class: {
                "with-social-media-container":
                  !_vm.site.isMenuHorizontalStyle && _vm.socialList.length > 0
              }
            },
            [
              _vm.isMegaMenuOpen && !_vm.menuList
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-center w-100 h-100"
                    },
                    [_c("loading-indicator")],
                    1
                  )
                : _vm.isMegaMenuOpen
                ? _c("div", [
                    !_vm.isMobile
                      ? _c(
                          "div",
                          _vm._l(_vm.menuList, function(menuItem) {
                            return _c(
                              "li",
                              {
                                key: menuItem.name + "_desktop",
                                staticClass: "nav-item",
                                class: {
                                  open: _vm.isMenuOpen(menuItem)
                                },
                                on: {
                                  mouseover: function($event) {
                                    return _vm.loadSecondLevel(menuItem)
                                  },
                                  mouseleave: function($event) {
                                    return _vm.clearSecondLevel()
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "nav-link" },
                                  [
                                    _c(
                                      "transition",
                                      { attrs: { name: "slide" } },
                                      [
                                        _vm.isMenuOpen(menuItem)
                                          ? _c("mega-menu-second-level", {
                                              attrs: {
                                                "is-mobile": false,
                                                "menu-item": _vm.loadedMenuItem
                                              },
                                              on: {
                                                loadMenuItem:
                                                  _vm.loadSecondLevel,
                                                closeMegaMenu: function(
                                                  $event
                                                ) {
                                                  return _vm.megaMenuVisibilityChanged(
                                                    false
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    menuItem.isOuterLink
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "h-100 w-100 d-flex align-items-center justify-content-between",
                                            class: {
                                              "font-weight-bold":
                                                menuItem.style.isBold
                                            },
                                            attrs: {
                                              href: menuItem.link,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(menuItem.name) +
                                                "\n              "
                                            ),
                                            _vm.isArrowVisible(menuItem)
                                              ? _c("div", {
                                                  staticClass:
                                                    "icon-arrow arrow-right"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      : !_vm.hasSubMenu(menuItem) &&
                                        menuItem.link
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "h-100 w-100 d-flex align-items-center justify-content-between",
                                            class: {
                                              "font-weight-bold":
                                                menuItem.style.isBold
                                            },
                                            attrs: {
                                              to: _vm.getMenuLink(menuItem)
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(menuItem.name) +
                                                "\n              "
                                            ),
                                            _vm.isArrowVisible(menuItem)
                                              ? _c("div", {
                                                  staticClass:
                                                    "icon-arrow arrow-right"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      : _c(
                                          "a",
                                          {
                                            staticClass:
                                              "h-100 w-100 d-flex align-items-center justify-content-between",
                                            class: {
                                              "only-text": !_vm.hasSubMenu(
                                                menuItem
                                              ),
                                              "font-weight-bold":
                                                menuItem.style.isBold
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(menuItem.name) +
                                                "\n              "
                                            ),
                                            _vm.isArrowVisible(menuItem)
                                              ? _c("div", {
                                                  staticClass:
                                                    "icon-arrow arrow-right"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("hr")
                              ]
                            )
                          }),
                          0
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "transition",
                              { attrs: { name: "slide" } },
                              [
                                _vm.loadedMenuItem !== null
                                  ? _c("mega-menu-second-level", {
                                      attrs: {
                                        "is-mobile": true,
                                        "menu-item": _vm.loadedMenuItem
                                      },
                                      on: {
                                        clearSecondLevel: _vm.clearSecondLevel,
                                        loadMenuItem: _vm.loadSecondLevel,
                                        closeMegaMenu: function($event) {
                                          return _vm.megaMenuVisibilityChanged(
                                            false
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.isLoggedIn
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "nav-item d-lg-none d-block",
                                    class: {
                                      open:
                                        _vm.loadedMenuItem !== null &&
                                        _vm.loadedMenuItem.name ===
                                          _vm.profileObject.name
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.loadSecondLevel(
                                          _vm.profileObject
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "nav-link" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "h-100 w-100 d-flex align-items-center justify-content-between font-weight-bold"
                                        },
                                        [
                                          _c("div", { staticClass: "d-flex" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mr-2 position-relative",
                                                class: {
                                                  "badge-after upper-corner":
                                                    _vm.unreadMessagesCount > 0
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "avatar",
                                                  attrs: { src: _vm.userAvatar }
                                                })
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.$t("profilom")) +
                                                "\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "icon-arrow arrow-right"
                                          })
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("hr")
                                  ]
                                )
                              : _c(
                                  "li",
                                  {
                                    staticClass: "nav-item d-lg-none d-block",
                                    class: {
                                      open:
                                        _vm.loadedMenuItem !== null &&
                                        _vm.loadedMenuItem.name ===
                                          _vm.profileObject.name
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "h-100 w-100 d-flex align-items-center justify-content-between font-weight-bold",
                                        attrs: { to: "/login" }
                                      },
                                      [
                                        _c("div", { staticClass: "d-flex" }, [
                                          _c("div", {
                                            staticClass:
                                              "mega-menu-icon mr-2 login"
                                          }),
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "belepes_vagy_regisztracio"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "icon-arrow arrow-right"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("hr")
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _vm._l(_vm.menuList, function(menuItem) {
                              return _c(
                                "li",
                                {
                                  key: menuItem.name + "_mobile",
                                  staticClass: "nav-item d-lg-none d-block",
                                  class: {
                                    open:
                                      _vm.loadedMenuItem !== null &&
                                      _vm.loadedMenuItem.name === menuItem.name
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.loadSecondLevel(menuItem)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "nav-link" },
                                    [
                                      menuItem.isOuterLink
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "h-100 w-100 d-flex align-items-center justify-content-between",
                                              class: {
                                                "font-weight-bold":
                                                  menuItem.style.isBold
                                              },
                                              attrs: {
                                                href: menuItem.link,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(menuItem.name) +
                                                  "\n              "
                                              ),
                                              _vm.isArrowVisible(menuItem)
                                                ? _c("div", {
                                                    staticClass:
                                                      "icon-arrow arrow-right"
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        : !_vm.hasSubMenu(menuItem) &&
                                          menuItem.link
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "h-100 w-100 d-flex align-items-center justify-content-between",
                                              class: {
                                                "font-weight-bold":
                                                  menuItem.style.isBold
                                              },
                                              attrs: {
                                                to: _vm.getMenuLink(menuItem)
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(menuItem.name) +
                                                  "\n              "
                                              ),
                                              _vm.isArrowVisible(menuItem)
                                                ? _c("div", {
                                                    staticClass:
                                                      "icon-arrow arrow-right"
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              staticClass:
                                                "h-100 w-100 d-flex align-items-center justify-content-between",
                                              class: {
                                                "only-text": !_vm.hasSubMenu(
                                                  menuItem
                                                ),
                                                "font-weight-bold":
                                                  menuItem.style.isBold
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(menuItem.name) +
                                                  "\n              "
                                              ),
                                              _vm.isArrowVisible(menuItem)
                                                ? _c("div", {
                                                    staticClass:
                                                      "icon-arrow arrow-right"
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("hr")
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.site.isMenuHorizontalStyle
                              ? _vm._l(_vm.staticMenuList, function(menuItem) {
                                  return _c(
                                    "li",
                                    {
                                      key: menuItem.name + "_mobileStaticItem",
                                      staticClass:
                                        "nav-item d-lg-none d-block static-item"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "nav-link" },
                                        [
                                          menuItem.isOuterLink
                                            ? _c("a", {
                                                staticClass:
                                                  "h-100 w-100 d-flex align-items-center justify-content-between",
                                                class: {
                                                  "font-weight-bold":
                                                    menuItem.style.isBold
                                                },
                                                attrs: {
                                                  href: menuItem.link,
                                                  target: "_blank"
                                                },
                                                domProps: {
                                                  textContent: _vm._s(
                                                    menuItem.name
                                                  )
                                                }
                                              })
                                            : !_vm.hasSubMenu(menuItem) &&
                                              menuItem.link
                                            ? _c("router-link", {
                                                staticClass:
                                                  "h-100 w-100 d-flex align-items-center justify-content-between",
                                                class: {
                                                  "font-weight-bold":
                                                    menuItem.style.isBold
                                                },
                                                attrs: {
                                                  to: _vm.getMenuLink(menuItem)
                                                },
                                                domProps: {
                                                  textContent: _vm._s(
                                                    menuItem.name
                                                  )
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("hr")
                                    ]
                                  )
                                })
                              : _vm._e()
                          ],
                          2
                        )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          !_vm.site.isMenuHorizontalStyle && _vm.socialList.length > 0
            ? _c("div", { staticClass: "social-container w-100" }, [
                _c("div", { staticClass: "h-100 col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "socialmedia h-100 d-flex align-items-center justify-content-around flex-wrap",
                      attrs: { id: "panel_socialmedia" }
                    },
                    _vm._l(_vm.socialList, function(socialIcon, index) {
                      return _c(
                        "a",
                        {
                          key: "social-" + socialIcon.name + "-" + index,
                          attrs: {
                            href: socialIcon.link,
                            title: socialIcon.name,
                            target: "_blank"
                          },
                          on: {
                            click: function($event) {
                              return _vm.sendSocialGaEvent(
                                socialIcon.contentType
                              )
                            }
                          }
                        },
                        [
                          _c("div", {
                            class: "social-icon " + socialIcon.contentType
                          })
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    : _c(
        "div",
        { staticClass: "d-flex flex-wrap h-100 horizontal-style" },
        [
          _c(
            "b-carousel",
            {
              staticClass: "w-100",
              class: {
                "next-indicator-hidden":
                  _vm.currentMenuViewIndex === _vm.menuViewCount - 1,
                "prev-indicator-hidden": _vm.currentMenuViewIndex === 0
              },
              attrs: {
                interval: 0,
                controls: _vm.menuViewCount !== 1,
                indicators: false
              },
              model: {
                value: _vm.currentMenuViewIndex,
                callback: function($$v) {
                  _vm.currentMenuViewIndex = $$v
                },
                expression: "currentMenuViewIndex"
              }
            },
            _vm._l(_vm.menuViewCount, function(menuViewIndex) {
              return _c("b-carousel-slide", {
                key: menuViewIndex,
                scopedSlots: _vm._u(
                  [
                    {
                      key: "img",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center w-100 h-100 pl-4"
                            },
                            _vm._l(
                              _vm.getCurrentMenuItemsByViewIndex(menuViewIndex),
                              function(menuItem) {
                                return _c(
                                  "li",
                                  {
                                    key: menuItem.name + "_desktop",
                                    staticClass:
                                      "nav-item d-flex align-items-center h-100 cursor-pointer text-uppercase",
                                    class: {
                                      open: _vm.isMenuOpen(menuItem)
                                    },
                                    on: {
                                      mouseover: function($event) {
                                        return _vm.loadSecondLevel(menuItem)
                                      },
                                      mouseleave: function($event) {
                                        return _vm.clearSecondLevel()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "nav-link h-100" },
                                      [
                                        _c(
                                          "transition",
                                          { attrs: { name: "slide" } },
                                          [
                                            _vm.isMenuOpen(menuItem)
                                              ? _c("mega-menu-second-level", {
                                                  attrs: {
                                                    "is-mobile": false,
                                                    "menu-item":
                                                      _vm.loadedMenuItem
                                                  },
                                                  on: {
                                                    loadMenuItem:
                                                      _vm.loadSecondLevel,
                                                    closeMegaMenu: function(
                                                      $event
                                                    ) {
                                                      return _vm.megaMenuVisibilityChanged(
                                                        false
                                                      )
                                                    }
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        menuItem.isOuterLink
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "h-100 w-100 d-flex align-items-center justify-content-between text-center",
                                                class: {
                                                  "font-weight-bold":
                                                    menuItem.style.isBold
                                                },
                                                attrs: {
                                                  href: menuItem.link,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(menuItem.name) +
                                                    "\n                "
                                                ),
                                                _vm.hasSubMenu(menuItem)
                                                  ? _c("div", {
                                                      staticClass:
                                                        "ml-2 icon-arrow",
                                                      class: _vm.isMenuOpen(
                                                        menuItem
                                                      )
                                                        ? "mt-1 arrow-up"
                                                        : "mb-2 arrow-down"
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : !_vm.hasSubMenu(menuItem) &&
                                            menuItem.link
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "h-100 w-100 d-flex align-items-center justify-content-between text-center",
                                                class: {
                                                  "font-weight-bold":
                                                    menuItem.style.isBold
                                                },
                                                attrs: {
                                                  to: _vm.getMenuLink(menuItem)
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(menuItem.name) +
                                                    "\n                "
                                                ),
                                                _vm.hasSubMenu(menuItem)
                                                  ? _c("div", {
                                                      staticClass:
                                                        "ml-2 icon-arrow",
                                                      class: _vm.isMenuOpen(
                                                        menuItem
                                                      )
                                                        ? "mt-1 arrow-up"
                                                        : "mb-2 arrow-down"
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "h-100 w-100 d-flex align-items-center justify-content-between text-center",
                                                class: {
                                                  "only-text": !_vm.hasSubMenu(
                                                    menuItem
                                                  ),
                                                  "font-weight-bold":
                                                    menuItem.style.isBold
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(menuItem.name) +
                                                    "\n                "
                                                ),
                                                _vm.hasSubMenu(menuItem)
                                                  ? _c("div", {
                                                      staticClass:
                                                        "ml-2 icon-arrow",
                                                      class: _vm.isMenuOpen(
                                                        menuItem
                                                      )
                                                        ? "mt-1 arrow-up"
                                                        : "mb-2 arrow-down"
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            }),
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }